import { getCDNContent, resolveCDNDir } from '@gjensidige/se-content-helpers';

import { InsuranceHelper } from './InsuranceHelper';

export class AppConstants {
  static getAppText = (key: string): any => {
    const texts = JSON.parse(sessionStorage.getItem('app-texts') || '{}');
    return !InsuranceHelper.isEmptyObject(texts) && texts[key]
      ? texts[key]
      : '';
  };

  static fetchApplicationTexts = async (product: string) => {
    const baseUrl: string = resolveCDNDir();
    const textUrl = `${baseUrl}texts/app-webshop-se.json`;
    const appTexts = await getCDNContent(textUrl);
    if (appTexts) {
      sessionStorage.setItem('app-texts', JSON.stringify(appTexts));
    }
    const configUrl: string = AppConstants.buildConfigFilePath(
      baseUrl,
      product
    );
    const appConfig = await getCDNContent(configUrl);
    if (appConfig) {
      sessionStorage.setItem('product-config', JSON.stringify(appConfig));
    }
  };

  static storeTextsInSession = (sessionKey: string, appTexts: any) => {
    if (sessionKey && appTexts) {
      sessionStorage.setItem(sessionKey, JSON.stringify(appTexts));
    }
  };

  static getTextsFromSession = (sessionKey: string) => {
    let texts: any = [];
    if (sessionKey) {
      texts = JSON.parse(sessionStorage.getItem(sessionKey) || '[]');
    }
    return texts;
  };

  static buildConfigFilePath = (baseUrl: string, product: string) => {
    return `${baseUrl}maps/webshop-se/${product}-configurations.json`;
  };
}
